import createNewAccountConstants from '../../../../NewWalletModal/components/CreateNewAccount/constants';

const walletsThatCanBeCreated = (walletsAlreadyActive: string[]): string[] => {
  const availableOptions = createNewAccountConstants.AVAILABLE_OPTIONS;

  return availableOptions.filter(
    (option) => !walletsAlreadyActive.includes(option)
  );
};

export default walletsThatCanBeCreated;
